import React from "react";

interface ChevronIconProps extends React.SVGProps<SVGSVGElement> {
  expanded?: boolean;
}

export function ChevronIcon({ expanded, ...props }: ChevronIconProps): JSX.Element {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{
        transform: expanded ? "rotate(90deg)" : "rotate(0deg)",
        transition: "transform 0.15s ease-in-out",
        ...props.style,
      }}
      {...props}
    >
      <polyline points="9 18 15 12 9 6" />
    </svg>
  );
}
